<template>
	<div class="" id="pageTop" style="padding:1rem 1rem 10rem;">
		<div class="row">
			<div class="col-12 col-lg-3">
            </div>
            <div class="col-12 col-lg-6">
                <ul class="list-group">
                    <li class="list-group-item">
                        <div class="row">
                            <div class="col-12 my-3" align="right">
                                <button class="btn btn-link" @click="$router.push('/login')">
                                    Return to login.
                                </button>
                            </div>
                            <div class="col-12 my-4">
                                <h4 align="center">Create your District 7030 Conference account</h4>
                            </div>
                            <div class="col-12 my-2">
                                <label>Email address*</label>
                                <input type="email" class="form-control"  v-model="signup.email" />
                            </div>
                            <div class="col-12 my-2">
                                <label>Password*</label>
                                <input type="password" class="form-control"  v-model="pass" />
                            </div>
                            <div class="col-12 my-2">
                                <label>Confirm password*</label>
                                <input type="password" class="form-control"  v-model="pass1" />
                            </div>
                            <div class="col-12 my-2">
                                <hr size="1" />
                            </div>
                            <div class="col-12 my-2">
                                <label>First name*</label>
                                <input type="text" class="form-control"  v-model="signup.fname" />
                            </div>
                            <div class="col-12 my-2">
                                <label>Last name*</label>
                                <input type="text" class="form-control"  v-model="signup.lname" />
                            </div>
                            <div class="col-12 my-2">
                                <label>Phone*</label>
                                <VuePhoneNumberInput @update="getPhone" v-model="signup.phone" :preferred-countries="['US', 'GB', 'CA']" :fetch-country="true"/>
                            </div>
                            <div class="col-12 my-2">
                                <label>Gender*</label>
                                <select class="form-control"  v-model="signup.gender">
                                    <option value="" selected disabled>Please choose</option>
                                    <option>FEMALE</option> 
                                    <option>MALE</option> 
                                    <option>NON-BINARY</option> 
                                </select>
                            </div>
                            <div class="col-12 my-2">
                                <label>Country*</label>
                                <select class="form-control"  v-model="signup.country">
                                    <option value="" selected disabled>Please choose</option>
                                    <option value="ANGUILLA">ANGUILLA</option>
                                    <option value="ANTIGUA AND BARBUDA">ANTIGUA AND BARBUDA</option>
                                    <option value="ARUBA">ARUBA</option>
                                    <option value="BARBADOS">BARBADOS</option>
                                    <option value="BONAIRE">BONAIRE</option>
                                    <option value="CURACAO">CURAÇAO</option>
                                    <option value="DOMNICA">DOMINICA</option>
                                    <option value="FRENCH GUIANA">FRENCH GUIANA</option>
                                    <option value="GRENADA">GRENADA</option>
                                    <option value="GUADELOUPE">GUADELOUPE</option>
                                    <option value="GUYANA">GUYANA</option>
                                    <option value="JAMAICA">JAMAICA</option>
                                    <option value="MARTINIQUE">MARTINIQUE</option>
                                    <option value="MONTSERRAT">MONTSERRAT</option>
                                    <option value="SAINT KITTS AND NEVIS">SAINT KITTS AND NEVIS</option>
                                    <option value="SAINT LUCIA">SAINT LUCIA</option>
                                    <option value="SAINT VINCENT AND THE GRENADINES">SAINT VINCENT AND THE GRENADINES</option>
                                    <option value="SURINAME">SURINAME</option>
                                    <option value="TRINIDAD AND TOBAGO">TRINIDAD AND TOBAGO</option>
                                    <option disabled>------</option>
                                    <option>OTHER</option>
                                </select>
                            </div>
                            <div class="col-12 my-2">
                                <label class="text-muted">Club*</label>
                                <select class="form-control" v-model="signup.club">
                                    <option disabled value="" selected>Please choose</option>
                                    <option>Other</option>
                                    <option>Not Aplicable</option>
                                    <option disabled>------</option>
                                    <option data-type="Rotarian">RC Antigua</option>
                                    <option data-type="Rotarian">RC Antigua Sundown</option>
                                    <option data-type="Rotarian">RC Arima</option>
                                    <option data-type="Rotarian">RC Aruba</option>
                                    <option data-type="Rotarian">RC Barbados</option>
                                    <option data-type="Rotarian">RC Barbados South</option>
                                    <option data-type="Rotarian">RC Barbados West</option>
                                    <option data-type="Rotarian">RC Basse Terre</option>
                                    <option data-type="Rotarian">RC Basse Terre Fort Saint Charles</option>
                                    <option data-type="Rotarian">RC Bequia</option>
                                    <option data-type="Rotarian">RC Bonaire</option>
                                    <option data-type="Rotarian">RC Cayenne</option>
                                    <option data-type="Rotarian">RC Cayenne-Est</option>
                                    <option data-type="Rotarian">RC Central Port of Spain</option>
                                    <option data-type="Rotarian">RC Chaguanas</option>
                                    <option data-type="Rotarian">RC Coeur Caraibes (Lamentin)</option>
                                    <option data-type="Rotarian">RC Corriverton</option>
                                    <option data-type="Rotarian">RC Curacao</option>
                                    <option data-type="Rotarian">RC Demerara</option>
                                    <option data-type="Rotarian">RC Diego Martin</option>
                                    <option data-type="Rotarian">RC Dominica</option>
                                    <option data-type="Rotarian">RC Felicity-Charlieville</option>
                                    <option data-type="Rotarian">RC Fort-de-France</option>
                                    <option data-type="Rotarian">RC Fort-de-France Ouest</option>
                                    <option data-type="Rotarian">RC Fort-de-France Sud</option>
                                    <option data-type="Rotarian">RC Francois</option>
                                    <option data-type="Rotarian">RC Garden City (Guyana)</option>
                                    <option data-type="Rotarian">RC Georgetown</option>
                                    <option data-type="Rotarian">RC Georgetown Central</option>
                                    <option data-type="Rotarian">RC Grande Terre Pointe Des Chateaux</option>
                                    <option data-type="Rotarian">RC Grenada</option>
                                    <option data-type="Rotarian">RC Grenada East</option>
                                    <option data-type="Rotarian">RC Gros Islet</option>
                                    <option data-type="Rotarian">RC Kourou</option>
                                    <option data-type="Rotarian">RC Lamentin</option>
                                    <option data-type="Rotarian">RC Liamuiga</option>
                                    <option data-type="Rotarian">RC Maracas-St. Joseph</option>
                                    <option data-type="Rotarian">RC Maraval</option>
                                    <option data-type="Rotarian">RC Marie-Galante</option>
                                    <option data-type="Rotarian">RC Montserrat</option>
                                    <option data-type="Rotarian">RC New Amsterdam</option>
                                    <option data-type="Rotarian">RC Paramaribo</option>
                                    <option data-type="Rotarian">RC Paramaribo Central</option>
									<option data-type="Rotarian">RC Paramaribo Quota</option>
                                    <option data-type="Rotarian">RC Paramaribo Residence</option>
                                    <option data-type="Rotarian">RC Penal</option>
                                    <option data-type="Rotarian">RC Piarco</option>
                                    <option data-type="Rotarian">RC Point Fortin</option>
                                    <option data-type="Rotarian">RC Pointe-A-Pierre</option>
                                    <option data-type="Rotarian">RC Pointe-a-Pitre Doyen</option>
                                    <option data-type="Rotarian">RC Pointe-a-Pitre Est</option>
                                    <option data-type="Rotarian">RC Pointe-a-Pitre Fleur d'Epee</option>
                                    <option data-type="Rotarian">RC Pointe-a-Pitre Jarry</option>
                                    <option data-type="Rotarian">RC Port of Spain</option>
                                    <option data-type="Rotarian">RC Port of Spain West</option>
                                    <option data-type="Rotarian">RC Portsmouth</option>
                                    <option data-type="Rotarian">RC Princes Town</option>
                                    <option data-type="Rotarian">RC Remire Montjoly</option>
                                    <option data-type="Rotarian">RC Saint Pierre</option>
                                    <option data-type="Rotarian">RC Saint-Laurent Mana Ouest Guyanais</option>
                                    <option data-type="Rotarian">RC San Fernando</option>
                                    <option data-type="Rotarian">RC San Fernando-South</option>
                                    <option data-type="Rotarian">RC San Juan</option>
                                    <option data-type="Rotarian">RC Sangre Grande</option>
                                    <option data-type="Rotarian">RC Schoelcher</option>
                                    <option data-type="Rotarian">RC Southwest-Tobago</option>
                                    <option data-type="Rotarian">RC St. Augustine</option>
                                    <option data-type="Rotarian">RC St. Augustine West</option>
                                    <option data-type="Rotarian">RC St. Kitts</option>
                                    <option data-type="Rotarian">RC St. Lucia</option>
                                    <option data-type="Rotarian">RC St. Vincent</option>
                                    <option data-type="Rotarian">RC St. Vincent South</option>
                                    <option data-type="Rotarian">RC Stabroek-Georgetown</option>
                                    <option data-type="Rotarian">RC Tobago</option>
                                    <option data-type="Rotarian">RC Willemstad</option>        
                                    <option data-type="Rotaractor">RTC Antigua</option>
                                    <option data-type="Rotaractor">RTC Arima</option>
                                    <option data-type="Rotaractor">RTC Arima West</option>
                                    <option data-type="Rotaractor">RTC Aruba</option>
                                    <option data-type="Rotaractor">RTC Aruba</option>
                                    <option data-type="Rotaractor">RTC Barbados</option>
                                    <option data-type="Rotaractor">RTC Barbados</option>
                                    <option data-type="Rotaractor">RTC Barbados West</option>
                                    <option data-type="Rotaractor">RTC Cayenne</option>
                                    <option data-type="Rotaractor">RTC Central Port of Spain</option>
                                    <option data-type="Rotaractor">RTC Chaguanas</option>
                                    <option data-type="Rotaractor">RTC Curacao</option>
                                    <option data-type="Rotaractor">RTC F.R.E.S.H.</option>
                                    <option data-type="Rotaractor">RTC Felicity-Charlieville</option>
                                    <option data-type="Rotaractor">RTC Fort-de-France</option>
                                    <option data-type="Rotaractor">RTC Genesis of Suriname</option>
                                    <option data-type="Rotaractor">RTC Georgetown</option>
                                    <option data-type="Rotaractor">RTC Georgetown Central</option>
                                    <option data-type="Rotaractor">RTC Grenada</option>
                                    <option data-type="Rotaractor">RTC Grenada-East</option>
                                    <option data-type="Rotaractor">RTC Gros Islet</option>
                                    <option data-type="Rotaractor">RTC Gros Islet</option>
                                    <option data-type="Rotaractor">RTC Ile de Cayenne</option>
                                    <option data-type="Rotaractor">RTC Kingstown</option>
                                    <option data-type="Rotaractor">RTC Kourou</option>
                                    <option data-type="Rotaractor">RTC L.E.P. Francois</option>
                                    <option data-type="Rotaractor">RTC Lamentin</option>
                                    <option data-type="Rotaractor">RTC Linden</option>
                                    <option data-type="Rotaractor">RTC Maraval</option>
                                    <option data-type="Rotaractor">RTC Marie-Galante</option>
                                    <option data-type="Rotaractor">RTC Montserrat</option>
                                    <option data-type="Rotaractor">RTC Mount Hope</option>
                                    <option data-type="Rotaractor">RTC Nevis</option>
                                    <option data-type="Rotaractor">RTC New Amsterdam</option>
                                    <option data-type="Rotaractor">RTC Paramaribo</option>
                                    <option data-type="Rotaractor">RTC Penal</option>
                                    <option data-type="Rotaractor">RTC Piarco</option>
                                    <option data-type="Rotaractor">RTC Piarco (U.W.I)</option>
                                    <option data-type="Rotaractor">RTC Point Fortin</option>
                                    <option data-type="Rotaractor">RTC Pointe-a-Pitre</option>
                                    <option data-type="Rotaractor">RTC Pointe-a-Pitre</option>
                                    <option data-type="Rotaractor">RTC Ponte a Pierre</option>
                                    <option data-type="Rotaractor">RTC Port Of Spain</option>
                                    <option data-type="Rotaractor">RTC Port of Spain West</option>
                                    <option data-type="Rotaractor">RTC Roseau</option>
                                    <option data-type="Rotaractor">RTC Saint Pierre</option>
                                    <option data-type="Rotaractor">RTC Saint Pierre</option>
                                    <option data-type="Rotaractor">RTC San Fernando</option>
                                    <option data-type="Rotaractor">RTC San Fernando</option>
                                    <option data-type="Rotaractor">RTC San Fernando South</option>
                                    <option data-type="Rotaractor">RTC Sangre Grande</option>
                                    <option data-type="Rotaractor">RTC South Barbados</option>
                                    <option data-type="Rotaractor">RTC South St. Lucia</option>
                                    <option data-type="Rotaractor">RTC Southwest Tobago</option>
                                    <option data-type="Rotaractor">RTC St. Augustine</option>
                                    <option data-type="Rotaractor">RTC St. Augustine West</option>
                                    <option data-type="Rotaractor">RTC St. Kitts</option>
                                    <option data-type="Rotaractor">RTC St. Lucia</option>
                                    <option data-type="Rotaractor">RTC Stabroek</option>
                                    <option data-type="Rotaractor">RTC University of Guyana</option>
                                    <option data-type="Rotaractor">RTC UWI Cave Hill Barbados</option>
                                    <option data-type="Rotaractor">RTC UWI Cavehill</option>
                                </select>
                            </div>
                            <div class="col-12 my-3">
                                <label>
                                    <input type="checkbox" value="true"  v-model="signup.emailConsent" /> I consent to receive emails from Rotary International District 7030.* 
                                </label>
                            </div>
                            <div class="col-12 my-1">
                                <label>
                                    <input type="checkbox" value="true" v-model="signup.dataConsent" /> I agree to allow Rotary International District 7030 to store and process my personal data.*
                                </label>
                            </div>
                            <div class="col-12 my-2">
                                <small>
                                    By submitting this form you are agreeing to Rotary International District 7030's <a href="https://socaislands.com/legal-stuff" target="_legal">Terms and Privacy Policy</a>
                                </small>
                            </div>
                            <div class="col-12 my-1">
                                <button class="btn btn-block btn-primary btn-lg" :disabled="!isFormValid || isBusy" @click="btnContinueClick">
                                    <span v-show="!isBusy">Continue</span>
                                    <div class="spinner-border text-light" role="status" v-show="isBusy">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                </button>
                            </div>
                            
                        </div>
                    </li>
                </ul>
            </div>
            <div class="col-12 col-lg-3">
            </div>
		</div>
	</div>
</template>

<script>
    import Vue from 'vue'
	import VueToast from 'vue-toast-notification'
	import 'vue-toast-notification/dist/theme-sugar.css'
    import VuePhoneNumberInput from 'vue-phone-number-input'
    import 'vue-phone-number-input/dist/vue-phone-number-input.css'
    
    Vue.use(VueToast)

    const fb = require('../firebaseConfig')
	export default {
		name: 'Signup',
		filters: {

		},
		components: {
			VuePhoneNumberInput,
		},
		computed:{
			isFormValid(){
                if(!this.signup.fname) return false
                if(!this.signup.lname) return false
                if(!this.signup.email) return false
                if (!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.signup.email)) return false
                if(!this.signup.phone) return false
                if(!this.signup.club) return false
                if(!this.isPhoneValid) return false
                if(!this.signup.gender) return false
                if(!this.signup.country) return false
                if(!this.pass) return false
                if(this.pass != this.pass1) return false
                if(!this.signup.dataConsent) return false
                if(!this.signup.emailConsent) return false
                return true
            }
		},
		data(){
			return{
				isBusy: false,
                isPhoneValid: false,
                formError: '',
                pass: '',
                pass1:'',
                signup:{
                    fname:'',
                    lname:'',
                    email:'',
                    phone:'',
                    formattedPhone:'',
                    gender:'',
                    country:'',
                    dataConsent:'',
                    emailConsent:'',
                    UUID:'',
                    role:'subscriber',
                    signUpDate: Math.floor(Date.now()/1000),
                    updated:'',
                    club:'',   
                },
			}
		},
		methods:{
			btnContinueClick(){
                this.isBusy = true
                fb.firebase.auth().createUserWithEmailAndPassword(this.signup.email, this.pass)
                .then(async (userCredential) => {
                    let user = userCredential.user
                    this.signup.UUID = userCredential.user.uid
                    this.signup.role = "subscriber"
                    await user.updateProfile({
                        displayName: `${this.signup.fname} ${this.signup.lname}`,
                        phoneNumber: `${this.signup.phone}`,
                    }).then(function() {
                        console.log(`user display name updated.`)
                    }).catch(function(error) {
                        console.log(error.message)
                    });
                    let custDoc = await fb.usersCollection.add(this.signup).then((doc)=>{
                        console.log(`user account created.`)
                        return doc.id
                    })
                    console.log(custDoc)
                    fb.firebase.auth().currentUser.sendEmailVerification().then(()=> {
                        Vue.$toast.success("District 7030 Conference account created!", {position:"top"})
                    }).catch(function(error) {
                        console.log(error)
                    })
                    this.$store.dispatch("fetchProfile", user)
                    this.$router.push('/registrations/add')
                })
                .catch((error) => {
                    this.formError = error.message
                    this.isBusy = false
                    Vue.$toast.error(`Unable to create account: ${error.message}`, {position:"top"})
                });

            },
            getPhone(e){
                this.signup.formattedPhone = e.formattedNumber
                this.isPhoneValid = e.isValid
            },
		},

		mounted(){

        }

	}
</script>
